import React from 'react';
import { SelectOption } from '@lmig/lmds-react-select';

class FilterTableDataUtility {
  static Instance = null;

  static getInstance() {
    if (FilterTableDataUtility.Instance == null) FilterTableDataUtility.Instance = new FilterTableDataUtility();

    return this.Instance;
  }

  static buildFilterSelectOptions(property, array) {
    let distinctItems = [];
    for (let i = 0; i < array.length; i++) {
      let item = array[i];
      if (!distinctItems.includes(item[property])) distinctItems.push(item[property]);
    }
    let selectOptions = [];
    selectOptions.push(
      <SelectOption key="All" value="All">
        All
      </SelectOption>,
    );
    for (let i = 0; i < distinctItems.length; i++) {
      let itemValue = distinctItems[i];
      selectOptions.push(
        <SelectOption key={itemValue} value={itemValue}>
          {itemValue}
        </SelectOption>,
      );
    }

    return selectOptions;
  }

  static getFilteredResults(array, updatedFilteredOptions) {
    let filteredResults = [];
    let continueFilterCheck = true;

    for (let i = 0; i < array.length; i++) {
      continueFilterCheck = true;
      let item = array[i];
      for (let property = 0; property < updatedFilteredOptions.length; property++) {
        if (item[updatedFilteredOptions[property].key] !== updatedFilteredOptions[property].value) {
          continueFilterCheck = false;
        }
      }
      if (continueFilterCheck) {
        filteredResults.push(item);
      }
    }
    return filteredResults;
  }

  static getUpdatedFilterOptionsFromList(selectOptions) {
    let updatedFilteredOptions = [];

    for (var i = 0; i < selectOptions.length; i++) {
      if (selectOptions[i].value !== 'All') {
        let id = selectOptions[i].id;
        let property = selectOptions[i].id.split('-')[1];
        let selectedFilterOption = selectOptions[i].value;
        updatedFilteredOptions.push({ key: property, id: id, value: selectedFilterOption });
      }
    }
    return updatedFilteredOptions;
  }
}

export default FilterTableDataUtility;